// Major Italian cities with coordinates, used to set an agency HQ (sede) marker.
export const ITALIAN_CITIES = [
  { name: "Torino", region: "Piemonte", lat: 45.0703, lng: 7.6869 },
  { name: "Cuneo", region: "Piemonte", lat: 44.3841, lng: 7.5426 },
  { name: "Novara", region: "Piemonte", lat: 45.4469, lng: 8.6222 },
  { name: "Aosta", region: "Valle d'Aosta", lat: 45.7372, lng: 7.3206 },
  { name: "Milano", region: "Lombardia", lat: 45.4642, lng: 9.19 },
  { name: "Brescia", region: "Lombardia", lat: 45.5416, lng: 10.2118 },
  { name: "Bergamo", region: "Lombardia", lat: 45.6983, lng: 9.6773 },
  { name: "Monza", region: "Lombardia", lat: 45.5845, lng: 9.2744 },
  { name: "Bolzano", region: "Trentino-Alto Adige", lat: 46.4983, lng: 11.3548 },
  { name: "Trento", region: "Trentino-Alto Adige", lat: 46.0748, lng: 11.1217 },
  { name: "Verona", region: "Veneto", lat: 45.4384, lng: 10.9916 },
  { name: "Venezia", region: "Veneto", lat: 45.4408, lng: 12.3155 },
  { name: "Padova", region: "Veneto", lat: 45.4064, lng: 11.8768 },
  { name: "Vicenza", region: "Veneto", lat: 45.5455, lng: 11.5354 },
  { name: "Udine", region: "Friuli-Venezia Giulia", lat: 46.0711, lng: 13.2346 },
  { name: "Trieste", region: "Friuli-Venezia Giulia", lat: 45.6495, lng: 13.7768 },
  { name: "Genova", region: "Liguria", lat: 44.4056, lng: 8.9463 },
  { name: "La Spezia", region: "Liguria", lat: 44.1025, lng: 9.824 },
  { name: "Bologna", region: "Emilia-Romagna", lat: 44.4949, lng: 11.3426 },
  { name: "Modena", region: "Emilia-Romagna", lat: 44.6471, lng: 10.9252 },
  { name: "Parma", region: "Emilia-Romagna", lat: 44.8015, lng: 10.3279 },
  { name: "Rimini", region: "Emilia-Romagna", lat: 44.0678, lng: 12.5695 },
  { name: "Firenze", region: "Toscana", lat: 43.7696, lng: 11.2558 },
  { name: "Pisa", region: "Toscana", lat: 43.7159, lng: 10.4018 },
  { name: "Livorno", region: "Toscana", lat: 43.5485, lng: 10.3106 },
  { name: "Perugia", region: "Umbria", lat: 43.1107, lng: 12.3908 },
  { name: "Terni", region: "Umbria", lat: 42.5636, lng: 12.6427 },
  { name: "Ancona", region: "Marche", lat: 43.6158, lng: 13.5189 },
  { name: "Pesaro", region: "Marche", lat: 43.9102, lng: 12.9134 },
  { name: "Roma", region: "Lazio", lat: 41.9028, lng: 12.4964 },
  { name: "Latina", region: "Lazio", lat: 41.4676, lng: 12.9037 },
  { name: "L'Aquila", region: "Abruzzo", lat: 42.3498, lng: 13.3995 },
  { name: "Pescara", region: "Abruzzo", lat: 42.4643, lng: 14.2142 },
  { name: "Campobasso", region: "Molise", lat: 41.5603, lng: 14.6627 },
  { name: "Napoli", region: "Campania", lat: 40.8518, lng: 14.2681 },
  { name: "Salerno", region: "Campania", lat: 40.6824, lng: 14.7681 },
  { name: "Caserta", region: "Campania", lat: 41.0733, lng: 14.3324 },
  { name: "Bari", region: "Puglia", lat: 41.1171, lng: 16.8719 },
  { name: "Lecce", region: "Puglia", lat: 40.3515, lng: 18.1750 },
  { name: "Foggia", region: "Puglia", lat: 41.4622, lng: 15.5446 },
  { name: "Taranto", region: "Puglia", lat: 40.4644, lng: 17.2470 },
  { name: "Potenza", region: "Basilicata", lat: 40.6395, lng: 15.8056 },
  { name: "Matera", region: "Basilicata", lat: 40.6664, lng: 16.6043 },
  { name: "Cosenza", region: "Calabria", lat: 39.2983, lng: 16.2536 },
  { name: "Reggio Calabria", region: "Calabria", lat: 38.1113, lng: 15.6473 },
  { name: "Catanzaro", region: "Calabria", lat: 38.9098, lng: 16.5877 },
  { name: "Palermo", region: "Sicilia", lat: 38.1157, lng: 13.3615 },
  { name: "Catania", region: "Sicilia", lat: 37.5079, lng: 15.083 },
  { name: "Messina", region: "Sicilia", lat: 38.1938, lng: 15.554 },
  { name: "Cagliari", region: "Sardegna", lat: 39.2238, lng: 9.1217 },
  { name: "Sassari", region: "Sardegna", lat: 40.7259, lng: 8.5557 },
];
